import React from 'react'

import classnames from 'classnames'
import Immutable from 'immutable'

import type { Crop } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import GoustoImage from 'components/Image'

import type { DetailViewType } from '../types'

import css from './DetailImage.css'

type DetailImageProps = {
  media: Crop[]
  title?: string
  view?: DetailViewType
  mouseEnter?: () => void
  mouseLeave?: () => void
  maxMediaSize?: number | null
}

export const DetailImage = ({
  media,
  title = '',
  view = 'standard',
  mouseEnter = () => {},
  mouseLeave = () => {},
  maxMediaSize = null,
}: DetailImageProps) => (
  <div
    className={classnames(
      { [css.large]: view === 'large' },
      { [css.standard]: view === 'standard' },
      css.placeholder,
    )}
    onMouseEnter={mouseEnter}
    onMouseLeave={mouseLeave}
    data-testid="detail-image"
  >
    {media.length > 0 && (
      <GoustoImage
        media={Immutable.fromJS(media)}
        title={title}
        maxMediaSize={maxMediaSize}
        className={view === 'large' ? css.recipeImgLarge : css.recipeImgSmall}
      />
    )}
  </div>
)
